import YPagination from './Pagination';

export { YPagination };
export default YPagination;
